
<template>
  <!--新品商品-->
  <x-addEdit
    ref="addEdit"
    apiOrigin="PHP"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'addGoods',
  data () {
    return {
      urlValues: {},
      formList: [
        {
          label: '平台',
          inputType: 'select',
          options: [],
          placeholder: '请选择平台',
          props: ['platform', {
            rules: [
              { required: true, message: '请输入标题' }
            ]
          }]
        },
        {
          label: '标题',
          inputType: 'input',
          options: [],
          placeholder: '请输入标题',
          props: ['goods_name', {
            rules: [{ required: true, message: '请输入标题' }, {pattern: this.REG.nonEmpty, message: this.MESSAGE.nonEmpty}]
          }]
        },
        {
          label: '商品图片',
          inputType: 'upload',
          options: [],
          placeholder: '',
          fileList: [],
          uploadParam: {
            iconUrl: 'goods_img_url', // 返回url的字段
            iconName: 'goods_img_url', // 返回文件名称的字段

            accept: this.$store.state.imgAccept,
            listType: 'picture'
          },
          props: ['goods_img_url', {
            rules: [{ required: true, message: '请选择商品图片' }]
          }]
        },
        {
          label: '商品链接',
          inputType: 'input',
          options: [],
          placeholder: '请输入商品链接',
          props: ['goods_url', {
            rules: [
              { required: true, message: '请输入商品链接' },
              {type: 'url', message: '请输入正确的url格式'}
            ]
          }]
        },
        {
          label: '价格',
          inputType: 'input',
          options: [],
          placeholder: '请输入价格',
          blur: this.rateChange,
          props: ['original_price', {
            trigger: 'input',
            rules: [
              { required: true, message: '请输入价格' },
              { pattern: this.REG.nonnegative, message: this.MESSAGE.nonnegative }
            ]
          }]
        },
        {
          label: '优惠券',
          inputType: 'input',
          options: [],
          placeholder: '请输入优惠券',
          type: 'float',
          blur: this.rateChange,
          props: ['coupon_amount', {
            trigger: 'input',
            rules: [
              { pattern: this.REG.nonnegative, message: this.MESSAGE.nonnegative }
            ]
          }]
        },
        {
          label: '月销量',
          inputType: 'input',
          options: [],
          placeholder: '请输入月销量',
          type: 'float',
          props: ['sales_volume', {
            rules: [
              { pattern: this.REG.nonnegative, message: this.MESSAGE.nonnegative }
            ]
          }]
        },
        {
          label: '佣金比例',
          inputType: 'input',
          options: [],
          placeholder: '请输入佣金比例',
          type: 'float',
          blur: this.rateChange,
          props: ['commission_rate', {
            trigger: 'input',
            rules: [
              { pattern: this.REG.nonnegative, message: this.MESSAGE.nonnegative }
            ]
          }]
        },
        {
          label: '佣金',
          inputType: 'input',
          options: [],
          placeholder: '请输入佣金',
          type: 'float',
          disabled: true,
          props: ['commission', {
            trigger: 'input',
            rules: [
              { pattern: this.REG.nonnegative, message: this.MESSAGE.nonnegative }
            ]
          }]
        },
        {
          label: 'Android推广链接',
          inputType: 'input',
          options: [],
          placeholder: '请输入推广链接',
          props: ['android_share_url', {
            rules: [{type: 'url', message: '请输入正确的url格式'}]
          }]
        },
        {
          label: 'Android优惠券链接',
          inputType: 'input',
          options: [],
          placeholder: '请输入优惠券链接',
          props: ['android_coupon_url', {
            rules: [{type: 'url', message: '请输入正确的url格式'}]
          }]
        },
        {
          label: 'iOS推广链接',
          inputType: 'input',
          options: [],
          placeholder: '请输入推广链接',
          props: ['ios_share_url', {
            rules: [{type: 'url', message: '请输入正确的url格式'}]
          }]
        },
        {
          label: 'iOS优惠券链接',
          inputType: 'input',
          options: [],
          placeholder: '请输入优惠券链接',
          props: ['ios_coupon_url', {
            rules: [{type: 'url', message: '请输入正确的url格式'}]
          }]
        }
      ],
      formKey: {
        platform: '',
        goods_name: '',
        goods_img_url: '',
        goods_url: '',
        original_price: '',
        special_price: '',
        sales_volume: '',
        commission: '',
        commission_rate: '',
        coupon_amount: '',
        ios_share_url: '',
        ios_coupon_url: '',
        android_share_url: '',
        android_coupon_url: '',
        warehouse_id: ''
      },
      addParam: {
        url: '/market/share_goods',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/market/share_goods/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/market/share_goods/',
        resHandle: ''
      }
    };
  },
  created () {
    this.getPlatform();
  },
  mounted () {
  },
  methods: {
    /** 佣金比例修改事件 */
    rateChange () {
      let form = this.$refs.addEdit.form;
      form.resetFields(['commission']);
      form.validateFields(['original_price', 'coupon_amount', 'commission_rate'], (err, values) => {
        if (err) { return; }
        let formVal = {...values};
        for (let item in formVal) {
          formVal[item] && (formVal[item] = parseFloat(formVal[item]));
        }
        let rate = formVal.commission_rate;
        rate && (rate = rate * 0.01);

        if (formVal.coupon_amount || formVal.coupon_amount === 0) {
          if (formVal.original_price > formVal.coupon_amount) {
            let price = formVal.original_price - formVal.coupon_amount;
            let commission = price * rate;
            commission && commission.toFixed(2);
            (commission || commission === 0) && form.setFieldsValue({commission: commission});
          } else {
            this.$message.error('优惠券需小于原价格');
          }
        }
        if ((formVal.commission_rate || formVal.commission_rate === 0) &&
          !formVal.coupon_amount && formVal.coupon_amount !== 0) {
          this.$message.error('请输入优惠券');
        }
        // if ((formVal.coupon_amount || formVal.coupon_amount === 0) &&
        //   !formVal.commission_rate && formVal.commission_rate !== 0) {
        //   this.$message.error('请输入佣金比例');
        // }
      });
    },
    getPlatform () {
      this.typeSelect({ index: 0, query: 'market_platform_desc', scope: 'formList' });
    },
    detailResHandle (data) {
      return data;
    },
    reqHandle (param) {
      param.warehouse_id = this.getLocal('warehouseId');
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
